import { FILE_TYPE } from "../constants";
import { IChecklistUpload } from "./CheckLists";
import { Participant } from "./Participants";

export interface PracticalUploadedFile {
  fileId: string;
  file: File;
  fileType: FILE_TYPE;
  appliesTo?: SELECTED_COMPETENCY_TYPE;
  isFromUpload?: boolean;
  uploadId?: string;
  [key: string]: any;
}

export enum SELECTED_FILE_TYPE {
  DOCUMENT = "Document",
  CHECKLIST = "Checklist"
}

export enum SELECTED_COMPETENCY_TYPE {
  ALL = 1,
  SELECTED = 0
}

export interface PracticalPayload {
  id: string | null;
  name: string | null;
  description: string | null;
  location: string | null;
  weatherCondition: string | null;
  instructorId: string | null;
  practicalDate: string | null;
  practicalTime: string | null;
  durationInHours: string | null;
  isAssessment: boolean;
  practicalTypeId: string | null;
  requireParticipantConfirmation: boolean;
  attributeDefinitionIds: string[];
  participants: Participant[];
  attachmentUploadIds: string[];
  checklistAnswers: IChecklistUpload[];
  deletedAttachments: string[];
  deletedChecklistAssignmentIds: string[];
}

export interface FileToUpload {
  uploadIds: string[];
}

export interface AttachmentUpload {
  attachmentUploadId: string;
  appliesTo: SELECTED_COMPETENCY_TYPE;
}

export interface IInstructor {
  createdDate: string | null;
  email: string;
  employeeId: string;
  firstName: string;
  fullName: string;
  hasJob: boolean;
  hasProfilePicture: boolean;
  isCompliant: boolean;
  isInstructor: boolean;
  lastName: string;
  location: string;
  middleName: string | null;
  preferredName: string | null;
  role: string;
  status: number;
}
